import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UPDATE_NAV_ITEM } from 'store/modules/statspro/stat-comparison/actions';
import { statComparisonNavSelector } from 'store/modules/statspro/stat-comparison/selectors';

export const useStatComparisonNavSync = ({ competitions, seasons }) => {
    const dispatch = useDispatch();
    const nav = useSelector(statComparisonNavSelector);

    /**
     * Set initial nav values
     */
    useEffect(() => {
        if (competitions && !nav.competition.id) {
            const { PREMIERSHIP } = PULSE.app.common.CONSTANTS.PROVIDER_IDS;
            const aflPremiershipCompetition = competitions.find(
                (comp) => comp.providerId === PREMIERSHIP
            );

            if (aflPremiershipCompetition) {
                dispatch(
                    UPDATE_NAV_ITEM.request({
                        navItem: 'competition',
                        value: { id: aflPremiershipCompetition.id }
                    })
                );
            }
        }

        if (seasons && !nav.season.id) {
            dispatch(
                UPDATE_NAV_ITEM.request({
                    navItem: 'season',
                    value: { id: seasons[0].id }
                })
            );
        }
    }, [competitions, seasons]);
};
